import { render, staticRenderFns } from "./EngagementSection.vue?vue&type=template&id=0f83b8dc&scoped=true&"
import script from "./EngagementSection.vue?vue&type=script&lang=js&"
export * from "./EngagementSection.vue?vue&type=script&lang=js&"
import style0 from "./EngagementSection.vue?vue&type=style&index=0&id=0f83b8dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f83b8dc",
  null
  
)

export default component.exports